


















import Vue, { PropType } from "vue";

import { Language } from "@/store/types";

import LanguageIcon from "./LanguageIcon.vue";

export default Vue.extend({
  name: "ToggleLanguageButton",
  components: { LanguageIcon },
  props: {
    language: {
      type: Object as PropType<Language>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
